import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import ImpactHero, { heroImgStyles } from '~components/ImpactHero';
import { ConstrainedText } from '~components/Text';
import Infographic from '~components/Infographic';

// Page Navigation
import PageNav from '~components/PageNav';
import AdvocacyCard from '~components/PageCard/AdvocacyCard';
import CommunityCard from '~components/PageCard/CommunityCard';
import Champagne from '~components/Svg/Champagne';
import Shoe from '~components/Svg/Shoe';
import Bike from '~components/Svg/Bike';

const FundraisingPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Collecte de fonds virtuelle" desc="Description" />
      <ImpactHero title="Collecte de fonds virtuelle">
        <StaticImage style={heroImgStyles} src="../../images/virtual-fundraising.jpg" alt="" />
      </ImpactHero>
      <div tw="container">
        <ConstrainedText>
        2020 a marqué le lancement de <i>Au-delà de l’insuline</i>, <u>un programme de dons</u> individuels qui contribuera à accélérer l’exécution de la mission de FRDJ pour trouver de nouveaux traitements qui ralentiront, préviendront et un jour guériront le DT1. En 2021, les membres se sont engagés à verser 25 600 $ au projet de recherche CREATE visant à trouver des guérisons qui guérissent le DT1. 
        </ConstrainedText>
      </div>
      <div tw="container">
        <div tw="grid gap-6 lg:(grid-cols-2 gap-12)">
          <Infographic icon={<Champagne tw="text-blue h-36 w-auto" />} title="0,6 M$">
          0,6 M$ recueillirent lors du gala virtuel à travers la Colombie-Britannique 
          </Infographic>
          <Infographic icon={<Shoe tw="text-blue h-36 w-auto" />} title="2,5 M$">
          2,5 M$ recueillirent lors de la Marche pour la guérison du diabète Sun Life FRDJ, rebaptisée Party DT1 de FRDJ pour une guérison en 2020, avec un peu moins de 4 000 participants.
          </Infographic>
          <Infographic icon={<Bike tw="text-blue h-36 w-auto" />} title="1,9 M$">
          1,9 M$ recueillirent lors de l’édition virtuelle de l’événement Roulons pour vaincre le diabète Sun Life FRDJ, avec plus de 5 000 participants.
          </Infographic>
        </div>
        <PageNav previous={<AdvocacyCard />} next={<CommunityCard />} />
      </div>
    </Layout>
  );
};

export default FundraisingPage;
